<emma-input
    [ngModel]="strValue"
    (ngModelChange)="value = $event"
    [autofocus]="autofocus"
    [disabled]="disabled"
    [placeholder]="placeholder"
    [minlength]="minlength"
    [maxlength]="maxlength"
    [copyToClipboard]="copyToClipboard"
    [inputClass]="inputClass"
    ($focus)="$focus.emit($event)"
    ($blur)="onBlur()"
    ($keydown)="onKeyDown($event)"
></emma-input>
